module.exports = __webpack_public_path__ + "static/media/WBN_B2B_MANUFACTURERS_DISTRIBUTORS_BACKGROUND.27821ffb.svg";